import { Component, input } from '@angular/core';
import { SendStatus, SendStatusDisplayPipe } from '@workspace/ng-data-access';

@Component({
  selector: 'aura-send-status-chip',
  templateUrl: './send-status-chip.component.html',
  imports: [SendStatusDisplayPipe],
})
export class SendStatusChipComponent {
  status = input.required<SendStatus>();
  sendStatus = SendStatus;
}
